import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateLesson = () => {
  const navigate = useNavigate();

  const [roomUrl, setRoomUrl] = useState("");
  const [roomId, setRoomId] = useState("");
  const [copied, setCopied] = useState(false);

  // =========================================================
  // GENERATE RANDOM ROOM CODE
  // =========================================================

  const createRoomId = () => {
    const characters =
      "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

    let id = "";

    for (let i = 0; i < 6; i++) {
      const randomIndex =
        Math.floor(
          Math.random() * characters.length
        );

      id += characters[randomIndex];
    }

    return id;
  };

  // =========================================================
  // CREATE LESSON
  // =========================================================

  const createLesson = () => {
    const newRoomId =
      createRoomId();

    const newUrl =
      `${window.location.origin}/lesson/${newRoomId}`;

    setRoomId(newRoomId);
    setRoomUrl(newUrl);
    setCopied(false);
  };

  // =========================================================
  // COPY LINK
  // =========================================================

  const copyLink = async () => {
    if (!roomUrl) return;

    try {
      await navigator.clipboard.writeText(
        roomUrl
      );

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error(
        "Could not copy link:",
        err
      );
    }
  };

  // =========================================================
  // JOIN AS TUTOR
  // =========================================================

  const joinLesson = () => {
    if (!roomId) return;

    navigate(
      `/lesson/${roomId}`
    );
  };

  // =========================================================
  // PAGE
  // =========================================================

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#071225",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        boxSizing: "border-box"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "700px",
          background: "#102445",
          borderRadius: "24px",
          padding: "2.5rem",
          boxShadow:
            "0 20px 60px rgba(0,0,0,0.35)"
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "2rem"
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "2.3rem"
            }}
          >
            Create an Online Lesson
          </h1>

          <p
            style={{
              opacity: 0.75,
              marginTop: "0.75rem",
              lineHeight: 1.6
            }}
          >
            Generate a private lesson link
            and send it to your student.
          </p>
        </div>

        {!roomUrl ? (
          <div
            style={{
              textAlign: "center"
            }}
          >
            <button
              onClick={createLesson}
              style={{
                border: "none",
                borderRadius: "12px",
                padding: "1rem 1.6rem",
                background: "#2563eb",
                color: "white",
                fontSize: "1.05rem",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              + Create New Lesson
            </button>
          </div>
        ) : (
          <div>
            <div
              style={{
                background: "#071225",
                borderRadius: "14px",
                padding: "1.2rem",
                marginBottom: "1rem"
              }}
            >
              <div
                style={{
                  fontSize: "0.85rem",
                  opacity: 0.65,
                  marginBottom: "0.5rem"
                }}
              >
                LESSON CODE
              </div>

              <div
                style={{
                  fontSize: "1.6rem",
                  fontWeight: "bold",
                  letterSpacing: "0.15rem",
                  marginBottom: "1rem"
                }}
              >
                {roomId}
              </div>

              <div
                style={{
                  fontSize: "0.85rem",
                  opacity: 0.65,
                  marginBottom: "0.4rem"
                }}
              >
                STUDENT LINK
              </div>

              <div
                style={{
                  overflowWrap: "anywhere",
                  fontFamily: "monospace"
                }}
              >
                {roomUrl}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexWrap: "wrap"
              }}
            >
              <button
                onClick={copyLink}
                style={{
                  flex: "1 1 180px",
                  border: "none",
                  borderRadius: "10px",
                  padding: "0.9rem",
                  background: copied
                    ? "#16a34a"
                    : "#f59e0b",
                  color: copied
                    ? "white"
                    : "#111827",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                {copied
                  ? "✓ Link Copied"
                  : "Copy Student Link"}
              </button>

              <button
                onClick={joinLesson}
                style={{
                  flex: "1 1 180px",
                  border: "none",
                  borderRadius: "10px",
                  padding: "0.9rem",
                  background: "#2563eb",
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                Join Lesson
              </button>
            </div>

            <button
              onClick={createLesson}
              style={{
                width: "100%",
                marginTop: "0.75rem",
                border: "1px solid #38557c",
                borderRadius: "10px",
                padding: "0.8rem",
                background: "transparent",
                color: "white",
                cursor: "pointer"
              }}
            >
              Generate Different Link
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateLesson;